import React from 'react';
import './SuggestionButtons.css';

interface SuggestionButtonsProps {
  suggestions: string[];
  onSelect: (text: string) => void;
  disabled?: boolean;
}

const SuggestionButtons: React.FC<SuggestionButtonsProps> = ({
  suggestions,
  onSelect,
  disabled = false
}) => {
  if (!suggestions || suggestions.length === 0) {
    return null;
  }

  return (
    <div className="suggestion-buttons-container">
      <div className="suggestion-label">Quick responses:</div>
      <div className="suggestion-buttons">
        {suggestions.map((suggestion, index) => (
          <button
            key={index}
            className="suggestion-btn"
            onClick={() => onSelect(suggestion)}
            disabled={disabled}
          >
            {suggestion}
          </button>
        ))}
      </div>
    </div>
  );
};

export default SuggestionButtons;
